export class MarketResearchFeature {
    public readonly id: number;
    public readonly name: string;
    public readonly description: string;

    private constructor(id: number, name: string, description: string) {
        this.id = id;
        this.name = name;
        this.description = description;
    }

    public static None = new MarketResearchFeature(
        10,
        "none",
        "Market research not accessible"
    );
    public static Anytime = new MarketResearchFeature(
        20,
        "anytime",
        "Market research accessible any time"
    );
    public static AfterSigned = new MarketResearchFeature(
        30,
        "after signed",
        "Market research accessible after job order signed"
    );

    public static asArray = [
        MarketResearchFeature.AfterSigned,
        MarketResearchFeature.Anytime,
        MarketResearchFeature.None,
    ];

    public static fromId = (id: number) => {
        const marketResearch = MarketResearchFeature.asArray.find(
            i => i.id == id
        );
        if (!marketResearch) {
            console.error(`unknown market research id requested: ${id}`);
            return null;
        }

        return marketResearch;
    };
}
